import React, {Fragment, useCallback, useState} from "react";

import {deleteData, setData, setNewData} from "services/Indicators.service";
import {i18n} from "translate/i18n";

import {uniqueId} from "lodash";

import {toast} from "react-toastify";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {useParams} from "react-router";
import {arrayMove, SortableCont, SortableItem} from "./actions";
import {SelectPrincipalUnit, SelectUnit} from "../Select";
import Editor from "../Editor";
import {swalQuestion} from "../Swal";
import {setLog} from "../../services/Logs.service";
import {useUser} from "../../store/providers/app";

import { getCommentsById } from "../../services/Comments.service";
import {groupBy} from "../../utils/actions";

import CommentTable from "../Comments/commentTable";

export const EditableDefault = ({table, removeData, index, status,  usersIndicator = '', indicator = '', idEn}) => {

    const {id} = useParams()

    const {user} = useUser()

    const [newHeader, setNewHeader] = useState(table?.headers);
    const [newRows, setNewRows] = useState(table?.rows);
    const [position, setPosition] = useState(null);
    const [title, setTitle] = useState(table?.titulo)
    const [footer, setFooter] = useState(table?.footer)
    const [totalComments, setTotalComments] = useState(0)

    const queryClient = useQueryClient();

    const {isFetching} = useQuery(["comments_table", table.id],
        () => {
            return id && getCommentsById(id)
        }, {
            onSuccess: (response) => {

                if (response) {
                    let commentsIndicator = groupBy(response, 'type_input')
                    const total = commentsIndicator[`table-${table.id}`]?.filter(item => item.resolved === 0).length

                    setTotalComments(total)

                }
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false
        }
    )


    const editInputHeader = (value, index, position) => {
        const header = [...newHeader];

        header[index][position] = {...header[index][position], value: value.target.value}
        setNewHeader(header)
    }

    const editInputRow = (value, value_format, index, position) => {
        const rows = [...newRows];
        rows[index][position] = {...rows[index][position], value: value, value_format: value_format}

        setNewRows(rows)
    }

    const addHeader = () => {
        const totalColumns = newHeader ? newHeader[0]?.length : 1
        let header = []

        const type = !newHeader.length ? 'table_header' : 'table_subheader'

        for (let i = 1; i <= totalColumns; i++) {
            header.push({
                col: null,
                row: null,
                type: type,
                unit: null,
                unit_convert: null,
                value: "",
                value_format: ""
            })
        }

        setNewHeader([...newHeader, header])
    }

    const addRow = (position) => {

        if (!position) return

        const rows = [...newRows];

        let newRow = []
        newRow = rows[0]?.map(item => ({...item, value: '', value_format: ''}))

        const totalColumns = newHeader ? newHeader[0]?.length : 1

        if (!newRow) {
            for (let i = 1; i <= totalColumns; i++) {
                newRow.push({
                    col: 0,
                    row: 0,
                    type: "table_row",
                    unit: null,
                    unit_convert: null,
                    value: "",
                    value_format: "",
                    block_column: 0
                })
            }
        }

        rows.splice(position, 0, newRow)
        setNewRows(rows)
    }

    const formatColumn = (newValue, { action }, position) => {
        const rows = [...newRows];
        rows.map(item =>
            item[position].unit = newValue.value
        )
        setNewRows(rows)
    }

    const formatColumnBlock = (newValue, position) => {
        const rows = [...newRows];
        rows.map(item =>
            item[position].block_column = parseInt(newValue)
        )

        setNewRows(rows)
    }


    const formatRow = (newValue, { action }, position, rowPosition) => {
        const rows = [...newRows];
        rows[rowPosition][position].unit = newValue.value
        setNewRows(rows)
    }

    const addColumn = (position) => {

        if (!position) return

        const header = [...newHeader];
        const rows = [...newRows];

        let type = !newHeader.length ? 'table_header' : 'table_subheader'

        const newColumnRow = {
            col: null,
            row: null,
            type: "table_row",
            unit: null,
            unit_convert: null,
            value: "",
            value_format: "",
            block_column: 0,
        }

        header.map((item,index) => {
           if(header[index].length > 0) {
                type = item[0]?.type

                const newColumnsHeader = {
                    col: null,
                    row: index,
                    type: type,
                    unit: null,
                    unit_convert: null,
                    value: "",
                }

                return item.splice(position, 0, newColumnsHeader)
           }
        })

        rows.map(item => {
            return item.splice(position, 0, newColumnRow)
        })

        setNewHeader(header)
        setNewRows(rows)
    }

    const deleteTableHeader = (index) => {
        const header = [...newHeader];
        header.splice(index, 1);
        setNewHeader(header);
    }

    const deleteTableRows = (index) => {
        const rows = [...newRows];
        rows.splice(index, 1);
        setNewRows(rows);
    }

    const deleteTableColumn = (position) => {
        const header = [...newHeader]
        const rows = [...newRows];

        header.map(item => {
            return item.splice(position, 1);
        })

        rows.map(item => {
            return item.splice(position, 1);
        })

        setNewHeader(header)
        setNewRows(rows)
    }

    const userMutations = useMutation(async (data) => {
            return setData(table.id, data)
        }, {
            onSuccess: (res) => {
                setLog({
                    'title': 'UPDATE_TABLE_INDICATOR',
                    'description': 'Tabela atualizada',
                    'username': user.username,
                    'indicator_id': id,
                }).then((response) => {});

                toast.success(i18n.t('success.editData'))
                queryClient.invalidateQueries(['tables_indicator', id])
            },
            onError: (err) => {
                toast.error(i18n.t('error.badRequest'));
            }
        }
    )

    const saveData = () => {
        let data = {
            'title': title,
            'rows': newRows,
            'headers': newHeader,
            'footer': footer ? footer : ''
        }

        if (table.id) {
            swalQuestion(`<b>${i18n.t('questions.editData')}</b>`).then(res => {
                if (res.isConfirmed) {
                    userMutations.mutate(data)
                }
            })
        } else {

            table['title'] = title
            table['footer'] = footer

            setNewData(table).then(response => {
                setLog({
                    'title': 'CREATE_TABLE_INDICATOR',
                    'description': 'Criada nova tabela',
                    'username': user.username,
                    'indicator_id': id,
                }).then((response) => {});
                toast.success('Tabela criada com sucesso!')
            })
            queryClient.invalidateQueries(['tables_indicator', id])
        }

    }

    const onSortEnd = useCallback(({oldIndex, newIndex}) => {
        document.body.style.cursor = 'default';
        setNewRows(oldItems => arrayMove(oldItems, oldIndex, newIndex));
    }, []);

    const onChangeUnits = (newValue, { action }, position) => {
        const values = newValue.map(value => value.value)
        const newUnit = values.toString().replaceAll(',', '; ')

        newRows.map(item => item[position].unit_convert = newUnit)
    }

    const getDataFooter = (input, text) => {
        setFooter(text)
    }

    const handleDelete = (id) => {
        swalQuestion(`<b>Deseja excluir esta tabela?</b>`).then(res => {
            if (res.isConfirmed) {
                deleteTableMutations.mutate(id)
            }
        })
    }

    const deleteTableMutations = useMutation(async (id) => {
            return deleteData(id)
        }, {
            onSuccess: (res) => {
                toast.success('Tabela excluida com sucesso!')
                queryClient.invalidateQueries(['tables_indicator', id])
            },
            onError: (err) => {
                toast.error(i18n.t('error.badRequest'));
            }
        }
    )

    const duplicateTable = (language) => {

        if (idEn && language === 'en') {
            table['id'] = null;
            table['tableable_id'] = idEn;
            table['indicator_id'] = idEn;
            table['title'] = title
            table['footer'] = footer

            setNewData(table).then(response => {
                setLog({
                    'title': 'DUPLICATE_TABLE_INDICATOR',
                    'description': 'Duplicado tabela PT pata EN',
                    'username': user.username,
                    'indicator_id': id,
                }).then((response) => {});
                toast.success('Tabela criada com sucesso!')
            })
            queryClient.invalidateQueries(['tables_indicator', id])
        }

        if (language === 'pt') {
            table['id'] = null;
            table['tableable_id'] = id;
            table['indicator_id'] = id;
            table['title'] = title
            table['footer'] = footer

            setNewData(table).then(response => {
                setLog({
                    'title': 'DUPLICATE_TABLE_INDICATOR',
                    'description': 'Duplicado tabela PT',
                    'username': user.username,
                    'indicator_id': id,
                }).then((response) => {});
                toast.success('Tabela criada com sucesso!')
            })
            queryClient.invalidateQueries(['tables_indicator', id])

        }
    }

   // if(isFetching) return <Loading />

    return (
        <>
            <div className="row m-0">

                <div className="col-12  border-bottom px-3">
                    <div className="my-3">
                        <span className="form-label">Título</span>
                        <input className="form-control" value={title ? title : ''} onChange={(e) => setTitle(e.target.value)}/>
                    </div>
                </div>

                    <div className="col-12 d-flex gap-2 flex-wrap border-bottom ">
                        <div className="my-3">
                            <button type="button"
                                    className="btn btn-outline-secondary px-3 py-2"
                                    disabled={newHeader.length === 2 && newHeader[1]?.length > 0}
                                    onClick={() => addHeader()}>
                                Cabeçalho
                            </button>
                        </div>

                        <div className="btn-group dropdown my-3">
                            <button type="button"
                                    className="btn btn-outline-secondary dropdown-toggle px-3 py-2"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true" data-bs-auto-close="false" aria-expanded="false">
                                <span>Inserir linha</span>
                            </button>
                            <ul className="dropdown-menu dropdown-menu-custom shadow-sm pt-0">
                            <span className="dropdown-header bg-theme rounded-top text-center">
                                 <p className="my-1 text-uppercase"> {i18n.t('label.selectLine')} </p>
                            </span>

                                <div className="px-3 pt-2">
                                    <select className="form-select"
                                            onChange={(e) => setPosition(e.target.value)}>
                                        <option value="">{i18n.t('label.select')}</option>
                                        {newRows.map((row, index) =>
                                            row.map((item, i) => i === 0 &&
                                                <option key={index} value={index}>{item.value}</option>)
                                        )}
                                    </select>
                                    <div className="d-flex justify-content-between mt-3">
                                        <button type="button"
                                                className="btn btn-primary bi-plus-circle px-5 py-2"
                                                onClick={() => addRow(position)}>
                                            {i18n.t('buttons.addStart')}
                                        </button>

                                        <button type="button"
                                                className="btn btn-primary bi-plus-circle px-5 py-2"
                                                onClick={() => addRow(Number(position) + 1)}>
                                            {i18n.t('buttons.addEnd')}
                                        </button>
                                    </div>
                                </div>
                            </ul>
                        </div>

                        <div className="btn-group dropdown my-3">
                            <button type="button"
                                    className="btn btn-outline-secondary dropdown-toggle px-3 py-2"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true" data-bs-auto-close="false" aria-expanded="false">
                                <span>Inserir coluna</span>
                            </button>
                            <ul className="dropdown-menu dropdown-menu-custom shadow-sm pt-0">
                            <span className="dropdown-header bg-theme rounded-top text-center">
                                 <p className=" my-1 text-uppercase">Selecione a coluna</p>
                            </span>
                                <div className="px-3 pt-2">
                                    <select className="form-select"
                                            onChange={(e) => setPosition(e.target.value)}>
                                        <option value=""> {i18n.t('label.select')} </option>
                                        {newHeader[0].map((item, i) =>
                                            <option key={i} value={i}>{item.value}</option>
                                        )}
                                    </select>

                                    <div className="d-flex justify-content-between mt-3">
                                        <button type="button"
                                                className="btn btn-primary bi-plus-circle px-5 py-2"
                                                onClick={() => addColumn(position)}>
                                            {i18n.t('buttons.addStart')}
                                        </button>

                                        <button type="button"
                                                className="btn btn-primary bi-plus-circle px-5 py-2"
                                                onClick={() => addColumn(Number(position) + 1)}>
                                            {i18n.t('buttons.addEnd')}
                                        </button>
                                    </div>
                                </div>
                            </ul>
                        </div>
                        <div className="my-3">
                            <button type="button"
                                    className="btn btn-secondary px-3 py-2"
                                    onClick={() => duplicateTable('pt')}
                            >
                                <span>Duplicar tabela</span>
                            </button>
                        </div>
                        { idEn &&
                            <div className="my-3">
                                <button type="button"
                                        className="btn btn-secondary px-3 py-2"
                                        onClick={() => duplicateTable('en')}
                                >
                                    <span>Duplicar tabela para inglês</span>
                                </button>
                            </div>
                        }


                    </div>

            </div>

            <div className="table-responsive m-3">
                {newHeader &&
                    <table className="table table-bordered align-middle">
                        {newHeader?.map((head, index) => head.length > 0 && (
                            <Fragment key={index}>
                                {index === 0 && status !== 'finished' &&
                                    <thead key={`delete-columns-${uniqueId()}`} className="bg-light">
                                    {head.length > 1 &&
                                        <tr>
                                            <th/>
                                            {head?.map((_, position) =>
                                                <th key={`delete-columns-buttons-${uniqueId()}`}
                                                    className="text-center p-0">
                                                    <span className="text-danger bi-x-circle-fill" role="button"
                                                          onClick={() => deleteTableColumn(position)}/>
                                                </th>
                                            )}
                                            <th/>
                                        </tr>
                                    }
                                    </thead>
                                }
                                <thead key={index}>
                                <tr>
                                    <th/>
                                    { head?.map((column, position) =>
                                        <th className={`p-1 ${position === 0 && 'table-custom'}`} key={position}>
                                            <textarea value={column.value ? column.value : ''}
                                                      className="form-control border-0 fw-bolder" rows="3"
                                                      onChange={(e) => editInputHeader(e, index, position)}/>

                                        </th>
                                    )}
                                    { status !== 'finished' &&
                                        <th className="bg-light text-center p-0 align-middle">
                                            {index > 0 &&
                                                <span className="text-danger bi-x-circle-fill" role="button"
                                                      onClick={() => deleteTableHeader(index)}/>
                                            }
                                        </th>
                                    }
                                </tr>
                                </thead>
                            </Fragment>
                        ))}


                        { newRows?.map((row, index) => {
                            let block = "0";

                            if (row?.block_column === "1") {
                                block = "1";
                            }

                            return  (
                                <Fragment key={index}>
                                    { index === 0 &&
                                        <tbody>
                                        <tr className="bg-light">
                                            <td/>
                                            { row.map((item, position) =>
                                                <td key={`convert-${uniqueId()}`} className="text-center p-0" style={ { minWidth: "200px"} }>
                                                    {block === "0" && (
                                                        <div className="btn-group dropdown">
                                                            <button type="button" className="btn dropdown-toggle px-3 py-2 border-0 rounded-0" data-bs-toggle="dropdown"
                                                                    aria-haspopup="true" data-bs-auto-close="false" aria-expanded="false">
                                                                <span>{i18n.t('label.units')}</span>
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-custom shadow-sm p-3">

                                                                <div className="form-group">
                                                                    <label className="form-label">{i18n.t('label.unit')}</label>
                                                                    <SelectPrincipalUnit unit={item?.unit} onChangeUnits={formatColumn} position={position} />
                                                                </div>

                                                                <div className="form-group">
                                                                    <label className="form-label">{i18n.t('label.unitConvert')}</label>
                                                                    <SelectUnit units={item.unit_convert} onChangeUnits={onChangeUnits} position={position} />
                                                                </div>

                                                                { user.profile === 1 &&
                                                                    <div className="form-group">
                                                                        <label className="form-label">Bloquear coluna</label>
                                                                        <select className="form-control" defaultValue={item?.block_column} onChange={(e) => formatColumnBlock(e.target.value, position)}>
                                                                            <option value="0">Desbloquear</option>
                                                                            <option value="1">Bloquear</option>
                                                                        </select>
                                                                    </div>
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </td>

                                            )}
                                            <td style={{width: "30px"}} className="p-0 bg-light"/>
                                        </tr>
                                        </tbody>
                                    }
                                </Fragment>
                            )
                        }

                   )}

                        <SortableCont
                            onSortEnd={onSortEnd}
                            axis="y"
                            lockAxis="y"
                            lockToContainerEdges={true}
                            lockOffset={["30%", "50%"]}
                            helperClass="helperContainerClass"
                            useDragHandle={true}
                            onSortStart={() => (document.body.style.cursor = 'grabbing')}
                        >

                            { newRows.map((row, index) => (
                                <SortableItem
                                    key={`item-${index}`}
                                    index={index}
                                    rowPosition={index}
                                    row={row}
                                    newRows={newRows}
                                    editInputRow={editInputRow}
                                    deleteTableRows={deleteTableRows}
                                    formatRow={formatRow}
                                    status={status}
                                />
                            ))}
                        </SortableCont>
                    </table>
                }
            </div>

            <div className="p-3">
                <label className="form-label">{i18n.t('stage.footer')}</label>
                <Editor
                    handleChange={getDataFooter}
                    data={footer}
                    name="notas_de_rodape"
                />
            </div>

            <div className="accordion p-3" id="accordionComment">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                            Comentários <span className="badge text-bg-danger ms-2 bg-danger">{ totalComments ? totalComments : 0 }</span>
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionComment">
                        <div className="accordion-body">
                            <CommentTable
                                data={{'param': `table-${table.id}`, 'label': 'table'}}
                                tableId={table.id}
                                usersIndicator={usersIndicator}
                                indicator={indicator}
                            />
                        </div>
                    </div>
                </div>
            </div>


            { user.profile !== 7 &&

                <div className="row">
                    <div className="col">
                        <div className="d-flex gap-2 bg-light border-top justify-content-end p-3">

                            {!table.id

                                ? <button type="button" className="btn btn-outline-danger px-5 py-2"
                                          onClick={() => removeData(index)}>{i18n.t('buttons.delete')}</button>

                                : <button type="button" className="btn btn-danger px-5 py-2"
                                          onClick={() => handleDelete(table.id)}>{i18n.t('buttons.delete')}</button>
                            }

                            <button type="button" className="btn btn-success px-5 py-2"
                                    onClick={() => saveData()}>{i18n.t('buttons.save')}</button>

                        </div>
                    </div>
                </div>
            }
        </>
    )
}
